import script from "./HeroCompareShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroCompareShowcase.vue?vue&type=script&setup=true&lang=js"

import "./HeroCompareShowcase.vue?vue&type=style&index=0&id=bd9855c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd9855c0"]])

export default __exports__